/* eslint-disable array-element-newline */
import {LitElement, html} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import styles from './diamond-preview-shapes.component.scss?as=stylesheet';
import previewStyles from './diamond-preview.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class DiamondPreviewShapes extends LitElement {

	static get styles () {
		return [styles, previewStyles];
	}

	static get properties () {
		return {
			shape: String,
			shapes: Array
		};
	}

	constructor () {
		super();
	}

	handleShapeChange (shape) {
		this.shape = shape;
		this.dispatchEvent(new Event('change'));
	}

	renderShape (shape) {
		const buttonClasses = {
			active: this.shape === shape,
			'diamond-shape': true
		};

		const iconClasses = {
			'diamond-icon': true,
			[`icon-diamond-${shape?.toLowerCase()?.replace(/ /g, '-')}`]: true
		};

		return html`
			<button class="${classMap(buttonClasses)}" aria-label="Preview Diamond Shape: ${shape}" @click="${() => this.handleShapeChange(shape)}">
				<span class="${classMap(iconClasses)}" aria-hidden="true"></span>
			</button>
		`;
	}

	renderShapes () {
		return this.shapes.map(shape => this.renderShape(shape));
	}

	render () {
		return html`
			<div class="diamond-preview">
				<div class="diamond-preview--label">
					<div class="diamond-preview-title">View With Diamond Shape</div>
					<div class="diamond-preview-selection">${this.shape}</div>
				</div>
				<div class="diamond-shapes">
					${this.renderShapes()}
				</div>
			</div>
		`;
	}

};

defineCustomElement('rb-diamond-preview-shapes', DiamondPreviewShapes);
